<template>
<v-container style="text-align:center">
  <h1>Ils parlent de nous</h1>
  <br/>
  
  <!-- <v-row align="start" justify="space-around">
    <div 
    v-for="(article, i) in news" :key="i"
    class="d-flex flex-column justify-center align-center ma-3 oneNews"
    :class="{hasUrl: !!article.url}"
    @click="goTo(article)">
      <v-img :src="article.logo" contain height="50"/>
      <br/>
      <v-img :src="article.preview" contain width="180"/>
    </div>
  </v-row> -->

    <carousel 
    :autoplay="true" 
    :scrollPerPage="true"
    :perPageCustom="[[600, 2], [768, 3], [1024, 4], [1264, 6]]"
  >
      <slide v-for="(article, i) in news" :key="i">
        <div 
        class="d-flex flex-column justify-center align-center ma-3 oneNews"
        :class="{hasUrl: !!article.url}"
        @click="goTo(article)">
          <v-img :src="article.logo" contain height="50"/>
          <br/>
          <v-img :src="article.preview" contain width="180"/>
        </div>
      </slide>
    </carousel>

</v-container>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import { Carousel, Slide } from 'vue-carousel'

export default {
  components: {
    Carousel,
    Slide
  },
  computed: {
    ...mapGetters('strapi', ['news']),
  },
  methods: {
    ...mapActions('strapi', ['getNews']),
    goTo (article) {
      if (article.url) {
        window.open(article.url, '_blank')
      }
    }
  },
  async mounted () {
    this.getNews()
  }
}
</script>

<style scoped>
h3 {
  margin-top: 1em;
}
.oneNews {
  width: 180px;
}

.hasUrl {
  cursor: pointer;
}
</style>